import React, { useState } from 'react';
import { DataSourcesView } from './settings/DataSourcesView';
import { ModelsView } from './settings/ModelsView';
import { MeshView } from './settings/MeshView';
export const SettingsView = () => {
  const [activeSection, setActiveSection] = useState('account');
  const [formData, setFormData] = useState({
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@example.com',
    jobTitle: 'Product Manager',
    department: 'Marketing'
  });
  const handleInputChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', formData);
    // Show success message or handle errors
  };
  return <div className="flex h-full" data-id="element-742">
      {/* Settings Sidebar */}
      <div className="w-52 bg-gray-50 border-r border-gray-200 p-4" data-id="element-743">
        <h2 className="text-lg font-medium text-gray-700 mb-4" data-id="element-744">Settings</h2>
        <nav className="space-y-1" data-id="element-745">
          <button className={`flex items-center w-full px-3 py-2 text-sm font-medium rounded-md ${activeSection === 'account' ? 'bg-teal-500 text-white' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => setActiveSection('account')} data-id="element-746">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor" data-id="element-747">
              <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" data-id="element-748" />
            </svg>
            Account
          </button>
          <button className={`flex items-center w-full px-3 py-2 text-sm font-medium rounded-md ${activeSection === 'data' ? 'bg-teal-500 text-white' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => setActiveSection('data')} data-id="element-749">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor" data-id="element-750">
              <path d="M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z" data-id="element-751" />
              <path d="M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z" data-id="element-752" />
              <path d="M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z" data-id="element-753" />
            </svg>
            Data
          </button>
          <button className={`flex items-center w-full px-3 py-2 text-sm font-medium rounded-md ${activeSection === 'models' ? 'bg-teal-500 text-white' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => setActiveSection('models')} data-id="element-754">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor" data-id="element-755">
              <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" data-id="element-756" />
            </svg>
            Models
          </button>
          <button className={`flex items-center w-full px-3 py-2 text-sm font-medium rounded-md ${activeSection === 'mesh' ? 'bg-teal-500 text-white' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => setActiveSection('mesh')} data-id="element-757">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor" data-id="element-758">
              <path fillRule="evenodd" d="M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zm1 2v1h1V5h-1zM13 12a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1v-3a1 1 0 00-1-1h-3zm1 2v1h1v-1h-1zM6 10a1 1 0 011-1h1a1 1 0 110 2H7a1 1 0 01-1-1zM10 6a1 1 0 011-1h1a1 1 0 110 2h-1a1 1 0 01-1-1zM10 10a1 1 0 011-1h1a1 1 0 110 2h-1a1 1 0 01-1-1zM10 14a1 1 0 011-1h1a1 1 0 110 2h-1a1 1 0 01-1-1zM14 10a1 1 0 011-1h1a1 1 0 110 2h-1a1 1 0 01-1-1z" clipRule="evenodd" data-id="element-759" />
            </svg>
            Mesh
          </button>
          <button className={`flex items-center w-full px-3 py-2 text-sm font-medium rounded-md ${activeSection === 'history' ? 'bg-teal-500 text-white' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => setActiveSection('history')} data-id="element-760">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor" data-id="element-761">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" data-id="element-762" />
            </svg>
            History
          </button>
        </nav>
      </div>
      {/* Settings Content */}
      <div className="flex-1 p-6 bg-white overflow-auto" data-id="element-763">
        {activeSection === 'account' && <div data-id="element-764">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-765">
              Account Settings
            </h2>
            <form onSubmit={handleSubmit} data-id="element-766">
              <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6" data-id="element-767">
                <h3 className="text-lg font-medium text-gray-700 mb-4" data-id="element-768">
                  Personal Information
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4" data-id="element-769">
                  <div data-id="element-770">
                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-771">
                      First Name
                    </label>
                    <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md focus:ring-teal-500 focus:border-teal-500" data-id="element-772" />
                  </div>
                  <div data-id="element-773">
                    <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-774">
                      Last Name
                    </label>
                    <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md focus:ring-teal-500 focus:border-teal-500" data-id="element-775" />
                  </div>
                </div>
                <div className="mb-4" data-id="element-776">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-777">
                    Email Address
                  </label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md focus:ring-teal-500 focus:border-teal-500" data-id="element-778" />
                </div>
                <div className="mb-4" data-id="element-779">
                  <label htmlFor="jobTitle" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-780">
                    Job Title
                  </label>
                  <input type="text" id="jobTitle" name="jobTitle" value={formData.jobTitle} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md focus:ring-teal-500 focus:border-teal-500" data-id="element-781" />
                </div>
                <div data-id="element-782">
                  <label htmlFor="department" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-783">
                    Department
                  </label>
                  <select id="department" name="department" value={formData.department} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md focus:ring-teal-500 focus:border-teal-500" data-id="element-784">
                    <option value="Marketing" data-id="element-785">Marketing</option>
                    <option value="Sales" data-id="element-786">Sales</option>
                    <option value="Engineering" data-id="element-787">Engineering</option>
                    <option value="Finance" data-id="element-788">Finance</option>
                    <option value="HR" data-id="element-789">HR</option>
                    <option value="Operations" data-id="element-790">Operations</option>
                  </select>
                </div>
              </div>
              <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6" data-id="element-791">
                <h3 className="text-lg font-medium text-gray-700 mb-4" data-id="element-792">
                  Password
                </h3>
                <button type="button" className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400" data-id="element-793">
                  Change Password
                </button>
              </div>
              <div className="flex justify-end" data-id="element-794">
                <button type="submit" className="px-4 py-2 bg-teal-500 text-white rounded-md hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2" data-id="element-795">
                  Save Changes
                </button>
              </div>
            </form>
          </div>}
        {activeSection === 'data' && <DataSourcesView data-id="element-796" />}
        {activeSection === 'models' && <ModelsView data-id="element-797" />}
        {activeSection === 'mesh' && <MeshView data-id="element-798" />}
        {activeSection !== 'account' && activeSection !== 'data' && activeSection !== 'models' && activeSection !== 'mesh' && <div className="flex items-center justify-center h-full" data-id="element-799">
              <div className="text-center text-gray-500" data-id="element-800">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-801">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6v6m0 0v6m0-6h6m-6 0H6" data-id="element-802" />
                </svg>
                <h3 className="text-lg font-medium mb-1" data-id="element-803">
                  {activeSection.charAt(0).toUpperCase() + activeSection.slice(1)}{' '}
                  Settings
                </h3>
                <p className="text-sm" data-id="element-804">This section is under development.</p>
              </div>
            </div>}
      </div>
    </div>;
};